/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perquarter1Inputs */

const en_perquarter1 = /** @type {(inputs: Perquarter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ quarter`)
};

const de_perquarter1 = /** @type {(inputs: Perquarter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ Quartal`)
};

/**
* | output |
* | --- |
* | "/ quarter" |
*
* @param {Perquarter1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const perquarter1 = /** @type {((inputs?: Perquarter1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perquarter1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_perquarter1(inputs)
	return de_perquarter1(inputs)
});
export { perquarter1 as "perQuarter" }